export default __webpack_public_path__ + "static/media/vuesax-linear-book.80125257.svg";